module.exports = __webpack_public_path__ + "static/img/userCenterDetail-user2.f5a58c4d.png";